import { Component, Inject, Input } from '@angular/core';

import { SocialLoginService } from '../services';

@Component({
    selector: 'cmn-social-login',
    templateUrl: './social-login.component.html',
    styleUrls: [ './social-login.component.scss' ],
})

export class SocialLoginComponent {
    @Input() public readonly socials: string[];

    constructor(
        @Inject('SocialConfig') public readonly configuration,

        private readonly service: SocialLoginService,
    ) {}

    public signInWithGoogle() {
        this.service.singInWithGoogle();
    }

    public signInWithFacebook() {
        this.service.singInWithFacebook();
    }

    public signInWithDiscord() {
        this.service.signInWithDiscord();
    }

    public signInWithTwitch() {
        this.service.signInWithTwitch();
    }
}
